// extracted by mini-css-extract-plugin
module.exports = {"model":"supervisor_model__1A1x0"};